module.exports = __webpack_public_path__ + "static/media/Hawk319_2c.e3ae5149.svg";